// Alteration slip: a customer copy to bring back at pick-up and a tag to pin
// on the garment for the tailor, cut apart along the dashed line. Built as its
// own small page and printed the same way as the gift receipt.
import dayjs from "dayjs";
import { escapeHtml, printGiftReceipt } from "./giftReceipt";
import { formatMoney } from "./money";

const showDate = (d) => (d && dayjs(d).isValid() ? dayjs(d).format("ddd DD MMM YYYY") : d || "");

export function buildAlterationSlipHtml(alt, tillData) {
  const store = tillData?.tillAccess?.csBunit?.name || "";
  const row = (k, v) => (v ? `<tr><th>${escapeHtml(k)}</th><td>${escapeHtml(v)}</td></tr>` : "");
  const body = [
    row("Customer", [alt?.customerName, alt?.mobileNo].filter(Boolean).join(" · ")),
    row("Item", alt?.productName),
    row("Work", alt?.type),
    row("Note", alt?.notes),
    row("Tailor", alt?.tailor),
    row("From bill", alt?.orderDocumentNo),
    row("Ready by", showDate(alt?.promisedDate)),
    alt?.charge > 0 ? row("Charge", formatMoney(alt.charge, tillData)) : "",
  ].join("");
  const tag = [alt?.type, alt?.notes, alt?.tailor ? `Tailor: ${alt.tailor}` : "", `Ready ${showDate(alt?.promisedDate)}`].filter(Boolean).map(escapeHtml).join("<br>");
  return `<!doctype html><html><head><meta charset="utf-8"><title>Alteration slip</title><style>
body{font-family:Arial,Helvetica,sans-serif;width:72mm;margin:0 auto;padding:4mm 0;color:#000;font-size:12px}
h1{font-size:16px;text-align:center;margin:0 0 2mm}
.store{text-align:center;margin:0 0 3mm}
.no{text-align:center;font-size:18px;font-weight:bold;letter-spacing:1px;margin:2mm 0}
table{width:100%;border-collapse:collapse}
th,td{text-align:left;padding:1mm 0;vertical-align:top}
th{width:20mm;font-weight:normal}
.note{text-align:center;margin:3mm 0 0}
.cut{border-top:1px dashed #000;margin:5mm 0 3mm;text-align:center;font-size:10px}
</style></head><body>
<h1>ALTERATION SLIP</h1>
${store ? `<p class="store">${escapeHtml(store)}</p>` : ""}
<p class="no">${escapeHtml(alt?.documentNo || "")}</p>
<table>${body}</table>
<p class="note">Bring this slip to collect your garment.</p>
<div class="cut">cut here · garment tag</div>
<p class="no">${escapeHtml(alt?.documentNo || "")}</p>
<p class="note">${escapeHtml(alt?.customerName || "")}</p>
<p class="note">${tag}</p>
</body></html>`;
}

export const printAlterationSlip = (alt, tillData) => printGiftReceipt(buildAlterationSlipHtml(alt, tillData), "alteration slip");
